import { PAEventType } from '@dadohr/shared/domainTypes/productAnalytics';
import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { useUnsafeTranslation } from '../i18next';
import { FlexContainer } from '../layout/Flex';
import { useIsFreeTier } from '../services/organizationTier';
import { useProductAnalytics } from '../services/productAnalytics';
import { LinkExternal } from './LinkExternal';

export const TeaserBox = styled('div')((p) => ({
  textAlign: 'center',
  maxWidth: 680,
  background:
    'linear-gradient(90deg, rgba(106, 178, 251, 0.24) 14.06%, rgba(114, 228, 175, 0.24) 83.33%)',
  borderRadius: p.theme.custom.border.radius(2),
  color: p.theme.custom.colors.gray.w900,
  padding: p.theme.spacing(2)
}));

const HUBSPOT_FORM = 'https://share.hsforms.com/1qHyeb50hTS643VWPWGpeYw5e1hy';

export const TeaserBoxFreeTierForExperiences: React.FC = ({ children }) => {
  const { t } = useUnsafeTranslation();
  const isFreeTier = useIsFreeTier();
  const { trackEvent } = useProductAnalytics();
  if (!isFreeTier) {
    return null;
  }
  return (
    <FlexContainer justifyContent="center">
      <TeaserBox>
        <Typography variant="body1" component="p" style={{ marginBottom: 8 }}>
          {children}
        </Typography>
        <Typography>
          {t('Experiences is available with a paid Dado subscription.')}
        </Typography>
        <Typography>
          <LinkExternal
            style={{ textDecoration: 'underline' }}
            href={HUBSPOT_FORM}
            onClick={() => {
              trackEvent({
                eventType: PAEventType.OTHER,
                name: 'Demo Link Clicked',
                Explanation:
                  'Admin user clicks a link to the demo form, from within the Dado app'
              });
            }}
          >
            {t('Request more info')}
          </LinkExternal>
        </Typography>
      </TeaserBox>
    </FlexContainer>
  );
};
